<template>
  <div class="c-test-panel">
    <div class="panel__inner">
      <header class="test-header">
        <div class="test-title">
          <div>
            <span
              class="c-badge"
              :class="typeClass"
              v-if="toPage === 'teacher-report'"
              >{{ typeText }}</span
            >
            <span class="c-badge" :class="subjectClass" v-else>{{
              data.subject_name
            }}</span>
            <span class="wrap-title">{{ data.evaluate_name }}</span>
          </div>
          <div>
            <span class="meta-info">
              布置时间：{{ data.created }}
              <i class="h-diver"></i>
              创建人：{{ data.teacher_name }}
            </span>
          </div>
        </div>
        <div>
          <button
            class="button"
            :style="
              visibleVSReport ? 'visibility: visible' : 'visibility: hidden'
            "
            v-if="toPage !== 'teacher-report'"
            @click="onVSClick(data)"
          >
            查看班级对比报告
          </button>
          <button
            class="button is-default"
            @click="overExercise()"
            v-if="!type && typeClass === 'is-mt'"
          >
            查看练习内容
          </button>
          <button
            class="button is-default"
            @click="onDeleteClick(data)"
            v-if="canDelete"
          >
            全部删除
          </button>
        </div>
      </header>
      <ul>
        <li v-for="item in data.eva_list" :key="item.class_id + item.grade_id">
          <span class="c-class">{{ item.class_name }}</span>
          <span class="c-count"
            >完成人数：{{ item.finish_stu }}/{{ item.total_stu }}</span
          >
          <span class="c-master" v-if="toPage === 'class-report'">
            平均掌握程度：<i class="c-rate" :class="rateClass(item)">
              {{
                item.avg_ability || item.finish_stu
                  ? `${item.avg_ability}%`
                  : "--"
              }}</i
            >
          </span>
          <span class="c-master" v-else>
            平均正答率：<i class="c-rate" :class="rateClass(item)">
              {{
                item.avg_ability || item.finish_stu
                  ? `${item.avg_ability}%`
                  : "--"
              }}</i
            >
          </span>
          <span class="c-status" :class="getStatusClass(item)">{{
            getStatusText(item)
          }}</span>
          <div>
            <span class="c-view is-blue" @click="onDetailClick(data, item)"
              >查看报告</span
            >
            <span class="c-delete" @click="onDeleteClick(item)" v-if="canDelete"
              >删除</span
            >
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import dayjs from 'dayjs';
import { deleteEvaluate } from '@/api/pt';
import { unlocking } from '@/utils/access-control';
import { CENTER_DELETE, REPORT_VIEW } from '@/utils/access-code';

export default {
  name: 'TestPanel',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    type: {},
    toPage: {
      type: String,
      default: 'class-report',
    },
  },
  data() {
    return {
      canDelete: unlocking(CENTER_DELETE),
      canViewVSReport: unlocking(REPORT_VIEW),
    };
  },
  computed: {
    subjectClass() {
      const map = {
        1: 'is-en',
        2: 'is-math',
        3: 'is-cn',
        4: 'is-phy',
        5: 'is-che',
      };
      return map[this.data.subject_id] || 'is-math';
    },
    isCnOrEn() {
      return [1, 3].includes(this.data.subject_id);
    },
    typeClass() {
      const map = {
        31: 'is-mt',
        41: 'is-amt',
        // TODO:类型待确认
        33: 'is-weak', // 薄弱知识点
        32: 'is-wrong', // 高频错题
      };
      // return map[`${this.data.type}${this.data.source_type}`] || 'is-mt';
      // TODO:只展示同步练习？
      return map[`${this.data.type}${this.data.source_type}`];
    },
    typeText() {
      const m = {
        31: '同步练习',
        41: '个性化练习',
        // TODO:类型待确认
        43: '薄弱知识点',
        32: '高频错题',
      };
      return m[`${this.data.type}${this.data.source_type}`];
    },
    visibleVSReport() {
      return this.data.eva_list.length >= 2 && this.canViewVSReport;
    },
  },
  methods: {
    rateClass(item) {
      if (!item.finish_stu) {
        return 'is-gray';
      }
      if (item.avg_ability < 40) {
        return 'is-red';
      }
      if (item.avg_ability < 70) {
        return 'is-orange';
      }
      return 'is-green';
    },
    overExercise() {
      const userInfo = JSON.parse(localStorage.getItem('CRM_USER_INFO')) || {};
      this.$router.push({
        path: '/pt/exercise-content',
        query: {
          evaluateId: this.data.eva_list[0].evaluate_id,
          schoolId: userInfo.campusId,
          batchId: this.data.batch_id,
          fromType: this.data.type,
        },
      });
    },
    getStatusClass(item) {
      return item.finish_stu === item.total_stu ? 'is-green' : 'is-blue';
    },
    getStatusText(item) {
      return item.finish_stu === item.total_stu ? '已完成' : '进行中';
    },
    onVSClick(item) {
      const userInfo = JSON.parse(localStorage.getItem('CRM_USER_INFO')) || {};
      // 暂时删除逻辑
      // const current = dayjs().format('YYYY-MM-DD');
      // if (current < item.created) {
      //   this.$message({
      //     type: 'error',
      //     duration: 3000,
      //     message: '班级对比报告将在第二天00:00点更新  记得及时查看哦',
      //   });
      //   return;
      // }
      this.$router.push({
        path: '/pt/class-compare-report',
        query: {
          schoolId: userInfo.campusId,
          batchId: item.batch_id,
        },
      });
    },
    onDetailClick(data, item) {
      const userInfo = JSON.parse(localStorage.getItem('CRM_USER_INFO')) || {};
      this.$router.push({
        path: `/pt/${this.toPage}`,
        // path: '/pt/teacher-report',
        query: {
          evaluateId: item.evaluate_id,
          schoolId: userInfo.campusId,
          classId: item.class_id,
          batchId: data.batch_id,
          fromType: data.type,
          subjectId: data.subject_id,
        },
      });
    },
    onDeleteClick(item) {
      this.$confirm('一经确认，测评将被删除，已完成的学生数据也将被删除', '确定删除此次测评么？', {
        center: true,
        customClass: 'i-confirm',
      }).then(() => {
        this.deleteEvaluate(item);
      }).catch(() => {
        console.log('取消');
      });
    },
    deleteEvaluate(item) {
      const id = item.batch_id || item.evaluate_id;
      // 删除批次 or 单个测评
      const type = item.batch_id ? 1 : 2;
      const userInfo = JSON.parse(localStorage.getItem('CRM_USER_INFO')) || {};
      return deleteEvaluate({
        school_id: userInfo.campusId,
        teacher_id: userInfo.id,
        delete_type: type,
        id,
      }).then((res) => {
        console.log(res);
        if (res.code === 200 && res.data) {
          this.$message.success('删除成功');
          this.$emit('reload');
        } else {
          this.$message.error('删除失败');
        }
      }).catch(() => {
        this.$message.error('删除失败');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.c-test-panel {
  width: 100%;
  // background-image: url('~@/views/pt/images/bg_panel.png');
  background: rgba(118, 194, 255, 0.14);
  background-size: 100% 100%;
  box-sizing: border-box;
  margin-bottom: 20px;
  padding: 4px;
  border-radius: 12px;
  .panel__inner {
    background: #fff;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 12px;
    position: relative;
    &::before,
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      height: 30px;
      background-size: contain;
      background-repeat: no-repeat;
      width: 40px;
    }
    &::before {
      background-image: url("~@/views/pt/images/left.png");
      background-position: left bottom;
      left: 0;
    }
    &::after {
      background-image: url("~@/views/pt/images/right.png");
      right: 0;
      background-position: right bottom;
    }
  }
  .h-diver {
    width: 5px;
    visibility: hidden;
    height: 2px;
    display: inline-block;
  }
  .c-badge {
    min-width: 47px;
    height: 24px;
    background: #0dd4c8;
    border-radius: 6px;
    text-align: center;
    line-height: 24px;
    color: #fff;
    font-size: 0.1rem;
    padding: 0 5px;
    display: inline-block;
    vertical-align: top;
    &.is-phy {
      background: rgba(39, 172, 255, 1);
    }
    &.is-che {
      background: rgba(153, 98, 248, 1);
    }
    &.is-mt {
      background: #ffffff;
      color: #0dd4c8;
      border: 1px solid;
    }
    &.is-amt {
      color: #27acff;
      background: #ffffff;
      border: 1px solid;
    }
    &.is-weak {
      color: rgba(255, 141, 39, 1);
      background: #fff;
      border: 1px solid;
    }
    &.is-wrong {
      color: rgba(245, 108, 108, 1);
      background: #fff;
      border: 1px solid;
    }
  }
  .test-header {
    color: rgba(17, 31, 44, 1);
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 13px;
  }
  .test-title {
    width: 400px;
    // display: flex;
    // align-items: center;
    // flex-wrap: wrap;
    // width: 500px;
  }
  .wrap-title {
    // width: 400px;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-left: 10px;
  }
  .meta-info {
    color: rgba(17, 31, 44, 0.6);
    font-size: 14px;
    width: 400px;
  }
  @media screen and (max-width:1200px) {
    .test-header {
      .test-title,.meta-info {
        width: unset;
      }
    }
  }
  .button {
    color: rgba(33, 148, 255, 1);
    padding: 4px 12px;
    border-radius: 4px;
    border: 1px solid rgba(179, 219, 255, 1);
    font-size: 14px;
    & + .button {
      margin-left: 30px;
    }
    &.is-default {
      color: rgba(48, 49, 51, 0.8);
      border-color: rgba(220, 223, 230, 1);
    }
  }
  ul {
    padding-left: 50px;
  }
  li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: rgba(17, 31, 44, 0.6);
    font-family: PingFangSC-Regular, PingFang SC;
    height: 40px;
    i {
      font-style: normal;
    }
  }
  .c-status {
    position: relative;
    padding-left: 13px;
    &::after {
      content: "";
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 6px;
      height: 6px;
      border-radius: 50%;
      left: 0;
      background: currentColor;
    }
  }
  .is-green {
    color: rgba(103, 194, 58, 1);
  }
  .is-red {
    color: rgba(245, 108, 108, 1);
  }
  .is-orange {
    color: rgba(255, 203, 0, 1);
  }
  .is-blue {
    color: rgba(33, 148, 255, 1);
  }
  .c-class {
    width: 2rem;
  }
  .c-count {
    width: 1.50rem;
  }
  .c-master {
    width: 2.00rem;
  }
  .c-delete,
  .c-view {
    font-weight: bolder;
  }
  .c-delete {
    padding-left: 0.40rem;
  }
}
</style>
